import Toast from "components/cms/Toast";
import PricingStack from "components/cms/PricingStack";
import useCmsPage from "hooks/useCmsPage";
import {
  addDynamicPricingPage,
  getDynamicPricingPage,
  prepareDynamicPricingPage,
  updateDynamicPricingPage,
} from "api/dynamicpricingpage";
import { emptyDynamicPricing } from "utils/defaults";

export default function DynamicPricingPage() {
  const {
    form,
    setField,
    frMap,
    exists,
    loading,
    toast,
    setToast,
    save,
    saveSection,
    savingSection,
    isSectionDirty,
  } = useCmsPage({
    load: getDynamicPricingPage,
    create: addDynamicPricingPage,
    update: updateDynamicPricingPage,
    empty: emptyDynamicPricing,
    mapResponse: (res) => res.data?.data,
    prepare: prepareDynamicPricingPage,
  });

  const savePricing = (sectionId, keys) => {
    if (!exists) {
      save();
      return;
    }
    saveSection(sectionId, keys);
  };

  if (loading) {
    return <p className="mt-5 text-gray-600">Loading Dynamic Pricing…</p>;
  }

  return (
    <div className="mt-3">
      <Toast toast={toast} onClose={() => setToast(null)} />
      {!exists ? (
        <p className="mb-3 text-sm text-gray-500">
          Dynamic pricing is not saved yet. Fill the sections and click Save to
          create this page.
        </p>
      ) : null}
      <PricingStack
        heading="Dynamic pricing page"
        description="/pricing/dynamic"
        idPrefix="pricing-dynamic"
        form={form}
        setField={setField}
        frMap={frMap}
        exists={exists}
        savePricing={savePricing}
        savingSection={savingSection}
        isSectionDirty={isSectionDirty}
      />
    </div>
  );
}
